import { BlurEvent, ChangeEvent, DataHeader, LookupModelSearchEvent, LookupModelSelectionEvent, Snackbar, Textbox } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutPartialShipmentPlanningProfile } from "./autogen/AutogenLayoutPartialShipmentPlanningProfile";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";
import { LocationByTypeProps, LocationByTypeUtil } from "./LocationByTypeUtil";

export class PartialShipmentPlanningProfile extends AutogenLayoutPartialShipmentPlanningProfile {

    override onLoad(): void | Promise<void> {
        this.validateManifestProfileRecordExist();
        this.setProfileLayoutDataSourceToMainDatasource();
        this.setInBoundOutBoundTypeListener();

        this.textboxOrderResponsibilityLevel.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            this.clearResponsibilityCodes();
            this.removeBeforeLookupModelSearchListenerToResponsibilityCodes();
            this.createBeforeLookupListenerForResponsibilityCodes();
            this.mainDataSource.displayDataInBoundComponent(this.textboxResponsibilityCodes);
        });

        this.onResponsibilityLevelChange();
    }

    private validateManifestProfileRecordExist() {
        const manifestProfileUrl = "lme/dispatch/PartialShipmentPlanningProfile?mode=update&key=";
        const validateProps: DuplicateIdProps = {tableName: "manifest_profile", screenName: "PartialShipmentPlanningProfile", navigateToUrl: manifestProfileUrl};
        DuplicateId.configureIdTextbox(this.textboxManifestProfileId, validateProps);
    }

    private setProfileLayoutDataSourceToMainDatasource() {
        this.layoutProfileColor.profileDataSource = this.mainDataSource;
    }

    private setInBoundOutBoundTypeListener() {
        const locationProps: LocationByTypeProps = { stateType: 'S', zoneType: 'Z', locationType: 'L', useDefault: true };
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxInBoundToManifest, this.textboxInboundToLookupManifest, locationProps);
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxOutBoundFromManifest, this.textboxOutboundFromLookupManifest, locationProps);
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxInBoundToOrders, this.textboxInboundToLookupOrders, locationProps);
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxOutBoundFromOrders, this.textboxOutboundFromLookupOrders, locationProps);
    }

    private orderRespCodesBeforeLookupModelSearchListener: (event: LookupModelSearchEvent) => void;

    private clearResponsibilityCodes(): void {
        this.textboxResponsibilityCodes.clear();
        this.activeRow?.set("order_resp_codes", null);
    }

    private removeBeforeLookupModelSearchListenerToResponsibilityCodes(): void {
        if (this.orderRespCodesBeforeLookupModelSearchListener) {
            this.textboxResponsibilityCodes.removeBeforeLookupModelSearchListener(this.orderRespCodesBeforeLookupModelSearchListener);
        }
    }

    private createBeforeLookupListenerForResponsibilityCodes() {
        this.orderRespCodesBeforeLookupModelSearchListener = (event) => {
            if (this.activeRow?.isNull("order_resp_level")) {
                event.stop();
                return;
            }
            event.filter.hierarchy_level = this.activeRow?.getNumber("order_resp_level");
        };
        this.textboxResponsibilityCodes.addBeforeLookupModelSearchListener(this.orderRespCodesBeforeLookupModelSearchListener);
    }

    private onResponsibilityLevelChange() {
        this.textboxOrderResponsibilityLevel.addChangeListener((event: ChangeEvent) => {
            const valueResponsibilityLevel = StringUtil.isEmptyString(event.newValue);
            if (valueResponsibilityLevel) {
                this.clearResponsibilityCodes();
                this.mainDataSource.displayDataInBoundComponent(this.textboxResponsibilityCodes);
            }
        });
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
        dataHeader.promptToSaveChanges();
    }

    textboxDaysOutManifestOnBlur(event: BlurEvent) {
        const daysOutManifest = (event.target as Textbox).text;
        if (!this.validateNumericInput(daysOutManifest, "manifest_days")) {
            return;
        }
    }

    textboxDaysOutAvailableOrdersOnBlur(event: BlurEvent) {
        const daysOutOrders = (event.target as Textbox).text;
        if (!this.validateNumericInput(daysOutOrders, "order_days")) {
            return;
        }
    }

    validateNumericInput = (value: any, fieldName: string): boolean => {
        if (StringUtil.isEmptyString(value)) {
            this.activeRow.set({[fieldName]: 10 });
            return true;
        }

        const parsedValue = parseInt(value);
        if (typeof parsedValue !== "number" || isNaN(parsedValue)) {
            Snackbar.showWarningSnackbar("Only valid numeric values are allowed.");
            this.activeRow.set({[fieldName]: 10 });
            return false;
        }
        if (parsedValue < 0) {
            Snackbar.showWarningSnackbar("Only positive numeric values are allowed.");
            this.activeRow.set({[fieldName]: 10 });
            return false;
        }
        return true;
    }


}
